/* eslint-disable sonarjs/no-identical-functions, sonarjs/no-duplicate-string */
import { Inject, Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import {
  map,
  switchMap,
  catchError,
  tap,
  withLatestFrom,
} from 'rxjs/operators';

import {
  saveBrighterFederationPartnerData,
  saveBrighterFederationPartnerDataSuccess,
  saveBrighterFederationPartnerDataError,
} from './chcp-federation.actions';

import { of } from 'rxjs';

import { Router } from '@angular/router';

import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { UserFacade } from '@cigna/chcp/shared/user-profile-data-access';
import { ChcpFederationService } from '../chcp-federation/chcp-federation.service';
import { WindowService } from '@cigna/shared/angular/core/window-util';

@Injectable()
export class ChcpFederationEffects {
  isAuth0 = false;

  constructor(
    private actions$: Actions,
    private authFacade: AuthFacade,
    private userFacade: UserFacade,
    private chcpFederationService: ChcpFederationService,
    private window: WindowService,
    private router: Router,
    @Inject(ENVIRONMENT_CONFIG) public envConfig: EnvironmentConfig,
  ) {
    this.isAuth0 = this.envConfig.authMethod === 'auth0';
  }

  saveBrighterFederationPartnerData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(saveBrighterFederationPartnerData),
      withLatestFrom(this.authFacade.userid$, this.userFacade.userProfile$),
      switchMap(([, userId, userProfile]) => {
        const requestObj = {
          userId: userId || '',
        };
        return this.chcpFederationService
          .putFederationPartnerData(requestObj, 'brighter')
          .pipe(
            map(() => saveBrighterFederationPartnerDataSuccess()),
            catchError((error) =>
              of(saveBrighterFederationPartnerDataError({ error })),
            ),
          );
      }),
    ),
  );

  saveBrighterFederationPartnerDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveBrighterFederationPartnerDataSuccess),
        tap(() => {
          if (this.isAuth0) {
            const queryParams = { key: 'brighter' };
            const urlTree = this.router.createUrlTree(['/linkrouter'], {
              queryParams,
            });
            const url = this.router.serializeUrl(urlTree);

            this.window.open(url, '_blank', 'noopener');
          } else {
            this.window.open(
              this.envConfig.redirect.brighter,
              '_blank',
              'noopener',
            );
          }
        }),
      ),
    { dispatch: false },
  );
}
